export class ExternalApps {
    initialize = (config) => {
        this.config = config;
    };

    getAppInfo(appName) {
        var app = this.config[appName];
        return {
            clientId: app.clientId,
            callbackUrl: `${app.baseUrl}/callback`
        }
    }
}

const externalApps = new ExternalApps();
export default externalApps;

